export default "__VITE_ASSET__yd6pMElR__"